import axios from "axios"
import {makeUseAxios} from "axios-hooks"
import LRU from "lru-cache"

export const bpnAPI = axios.create({baseURL: `${window._env_.REACT_APP_BPN_ADMIN_API}`});
export const useAxiosBpn = makeUseAxios({axios: bpnAPI})
export const museumsAPI = axios.create({baseURL: `${window._env_.REACT_APP_MUSEUMS_API}`})
export const useAxiosMuseums = makeUseAxios({axios: museumsAPI, cache: new LRU({max: 500})})
